export default [
[
       {name: 'Local Mitigation Planning', path: '/local'},
       {name: 'Local Capabilities', path: '/local/capabilities'},


       
    ]
]